var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row mt-5"},[_c('div',{staticClass:"col-md-1"}),_c('div',{staticClass:"card col-md-5"},[_c('Graph')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }